//============ fixf.core.services.organization.RealtyMgeComQueryPara =============
/* eslint-disable camelcase */
import {QueryParameter} from '@/base/QueryParameter';

export class RealtyMgeComQueryPara extends QueryParameter {
    constructor() {
        super();
    }

    _QueryAttr_OrgCode = 'orgCode';
    _QueryAttr_OrgName = 'orgName';
    _QueryAttr_CantonCode = 'cantonCode';
    _QueryAttr_OrgCodeValidTime = 'orgCodeValidTime';
    _QueryAttr_ContactPerson = 'contactPerson';
    _QueryAttr_ContactTel = 'contactTel';
    _QueryAttr_OfficePhone = 'officePhone';
    _QueryAttr_FaxNumber = 'faxNumber';
    _QueryAttr_ZipCode = 'zipCode';
    _QueryAttr_Email = 'email';
    _QueryAttr_CreateDate = 'createDate';
    _QueryAttr_IsDelete = 'isDelete';
    _QueryAttr_Address = 'address';
    _QueryAttr_OrgCodeFileID = 'orgCodeFileID';
    _QueryAttr_EaAreaCode = 'eaAreaCode';
    _QueryAttr_ThreeInOne = 'threeInOne';
    _QueryAttr_IsAuthen = 'isAuthen';
    _QueryAttr_LegalRep = 'legalRep';
    _QueryAttr_LegalRepTel = 'legalRepTel';
    _QueryAttr_BusinessLicenseNo = 'businessLicenseNo';
    _QueryAttr_LicenseNo = 'licenseNo';
    _QueryAttr_LicenseLevel = 'licenseLevel';
    _QueryAttr_LicenseValidTime = 'licenseValidTime';
    _QueryAttr_LicenseNoFileID = 'licenseNoFileID';
    _QueryAttr_IsLocal = 'isLocal';
    _QueryAttr_LegalRepIDCard = 'legalRepIDCard';
    _QueryAttr_EstablishmentDate = 'establishmentDate';
    _OrderAttr_OrgCode = 'orgCode';
    _OrderAttr_OrgName = 'orgName';
    _OrderAttr_CantonCode = 'cantonCode';
    _OrderAttr_OrgCodeValidTime = 'orgCodeValidTime';
    _OrderAttr_ContactPerson = 'contactPerson';
    _OrderAttr_ContactTel = 'contactTel';
    _OrderAttr_OfficePhone = 'officePhone';
    _OrderAttr_FaxNumber = 'faxNumber';
    _OrderAttr_ZipCode = 'zipCode';
    _OrderAttr_Email = 'email';
    _OrderAttr_CreateDate = 'createDate';
    _OrderAttr_IsDelete = 'isDelete';
    _OrderAttr_Address = 'address';
    _OrderAttr_OrgCodeFileID = 'orgCodeFileID';
    _OrderAttr_ThreeInOne = 'threeInOne';
    _OrderAttr_IsAuthen = 'isAuthen';
    _OrderAttr_LegalRep = 'legalRep';
    _OrderAttr_LegalRepTel = 'legalRepTel';
    _OrderAttr_BusinessLicenseNo = 'businessLicenseNo';
    _OrderAttr_LicenseNo = 'licenseNo';
    _OrderAttr_LicenseLevel = 'licenseLevel';
    _OrderAttr_LicenseValidTime = 'licenseValidTime';
    _OrderAttr_LicenseNoFileID = 'licenseNoFileID';
    _OrderAttr_IsLocal = 'isLocal';
    _OrderAttr_LegalRepIDCard = 'legalRepIDCard';
    _OrderAttr_EstablishmentDate = 'establishmentDate';


    /*cantonCodes:String[]*/
    setParamByCantonCode_Enum(cantonCodes) {
        this.addParameterByEnum(this._QueryAttr_CantonCode, cantonCodes);
    }

    /*isDelete:boolean*/
    setParamByIsDelete(isDelete) {
        this.addParameter(this._QueryAttr_IsDelete, isDelete);
    }

    /*isAuthen:boolean*/
    setParamByIsAuthen(isAuthen) {
        this.addParameter(this._QueryAttr_IsAuthen, isAuthen);
    }

    /*orgCode:String*/
    setParamByOrgCode(orgCode) {
        this.addParameter(this._QueryAttr_OrgCode, orgCode);
    }

    /*orgCodes:String[]*/
    setParamByOrgCode_Enum(orgCodes) {
        this.addParameterByEnum(this._QueryAttr_OrgCode, orgCodes);
    }

    /*cantonCode:String*/
    setParamByCantonCode(cantonCode) {
        this.addParameter(this._QueryAttr_CantonCode, cantonCode);
    }

    /*orgName:String*/
    setParamByOrgName(orgName) {
        this.addParameter(this._QueryAttr_OrgName, orgName);
    }

    /*startDate:Date, endDate:Date*/
    setParamByCreateDate_Range(startDate, endDate) {
        this.addDateParameterByRange(this._QueryAttr_CreateDate, startDate, endDate);
    }

    /*startDate:Date, endDate:Date*/
    setParamByEstablishmentDate_Range(startDate, endDate) {
        this.addDateParameterByRange(this._QueryAttr_EstablishmentDate, startDate, endDate);
    }

    /*emails:String[]*/
    setParamByEmail_Enum(emails) {
        this.addParameterByEnum(this._QueryAttr_Email, emails);
    }

    /*createDate:Date*/
    setParamByCreateDate(createDate) {
        this.addParameter(this._QueryAttr_CreateDate, createDate);
    }

    /*email:String*/
    setParamByEmail(email) {
        this.addParameter(this._QueryAttr_Email, email);
    }

    /*address:String*/
    setParamByAddress(address) {
        this.addParameter(this._QueryAttr_Address, address);
    }

    /*addresss:String[]*/
    setParamByAddress_Enum(addresss) {
        this.addParameterByEnum(this._QueryAttr_Address, addresss);
    }

    /*orgNames:String[]*/
    setParamByOrgName_Enum(orgNames) {
        this.addParameterByEnum(this._QueryAttr_OrgName, orgNames);
    }

    /*orgCodeValidTime:Date*/
    setParamByOrgCodeValidTime(orgCodeValidTime) {
        this.addParameter(this._QueryAttr_OrgCodeValidTime, orgCodeValidTime);
    }

    /*startDate:Date, endDate:Date*/
    setParamByOrgCodeValidTime_Range(startDate, endDate) {
        this.addDateParameterByRange(this._QueryAttr_OrgCodeValidTime, startDate, endDate);
    }

    /*contactPerson:String*/
    setParamByContactPerson(contactPerson) {
        this.addParameter(this._QueryAttr_ContactPerson, contactPerson);
    }

    /*contactPersons:String[]*/
    setParamByContactPerson_Enum(contactPersons) {
        this.addParameterByEnum(this._QueryAttr_ContactPerson, contactPersons);
    }

    /*contactTel:String*/
    setParamByContactTel(contactTel) {
        this.addParameter(this._QueryAttr_ContactTel, contactTel);
    }

    /*contactTels:String[]*/
    setParamByContactTel_Enum(contactTels) {
        this.addParameterByEnum(this._QueryAttr_ContactTel, contactTels);
    }

    /*officePhone:String*/
    setParamByOfficePhone(officePhone) {
        this.addParameter(this._QueryAttr_OfficePhone, officePhone);
    }

    /*officePhones:String[]*/
    setParamByOfficePhone_Enum(officePhones) {
        this.addParameterByEnum(this._QueryAttr_OfficePhone, officePhones);
    }

    /*faxNumber:String*/
    setParamByFaxNumber(faxNumber) {
        this.addParameter(this._QueryAttr_FaxNumber, faxNumber);
    }

    /*faxNumbers:String[]*/
    setParamByFaxNumber_Enum(faxNumbers) {
        this.addParameterByEnum(this._QueryAttr_FaxNumber, faxNumbers);
    }

    /*zipCode:String*/
    setParamByZipCode(zipCode) {
        this.addParameter(this._QueryAttr_ZipCode, zipCode);
    }

    /*zipCodes:String[]*/
    setParamByZipCode_Enum(zipCodes) {
        this.addParameterByEnum(this._QueryAttr_ZipCode, zipCodes);
    }

    /*orgCodeFileID:String*/
    setParamByOrgCodeFileID(orgCodeFileID) {
        this.addParameter(this._QueryAttr_OrgCodeFileID, orgCodeFileID);
    }

    /*orgCodeFileIDs:String[]*/
    setParamByOrgCodeFileID_Enum(orgCodeFileIDs) {
        this.addParameterByEnum(this._QueryAttr_OrgCodeFileID, orgCodeFileIDs);
    }

    /*threeInOne:boolean*/
    setParamByThreeInOne(threeInOne) {
        this.addParameter(this._QueryAttr_ThreeInOne, threeInOne);
    }

    /*legalRep:String*/
    setParamByLegalRep(legalRep) {
        this.addParameter(this._QueryAttr_LegalRep, legalRep);
    }

    /*legalReps:String[]*/
    setParamByLegalRep_Enum(legalReps) {
        this.addParameterByEnum(this._QueryAttr_LegalRep, legalReps);
    }

    /*legalRepTel:String*/
    setParamByLegalRepTel(legalRepTel) {
        this.addParameter(this._QueryAttr_LegalRepTel, legalRepTel);
    }

    /*legalRepTels:String[]*/
    setParamByLegalRepTel_Enum(legalRepTels) {
        this.addParameterByEnum(this._QueryAttr_LegalRepTel, legalRepTels);
    }

    /*businessLicenseNo:String*/
    setParamByBusinessLicenseNo(businessLicenseNo) {
        this.addParameter(this._QueryAttr_BusinessLicenseNo, businessLicenseNo);
    }

    /*businessLicenseNos:String[]*/
    setParamByBusinessLicenseNo_Enum(businessLicenseNos) {
        this.addParameterByEnum(this._QueryAttr_BusinessLicenseNo, businessLicenseNos);
    }

    /*licenseNo:String*/
    setParamByLicenseNo(licenseNo) {
        this.addParameter(this._QueryAttr_LicenseNo, licenseNo);
    }

    /*licenseNos:String[]*/
    setParamByLicenseNo_Enum(licenseNos) {
        this.addParameterByEnum(this._QueryAttr_LicenseNo, licenseNos);
    }

    /*licenseLevel:String*/
    setParamByLicenseLevel(licenseLevel) {
        this.addParameter(this._QueryAttr_LicenseLevel, licenseLevel);
    }

    /*licenseLevels:String[]*/
    setParamByLicenseLevel_Enum(licenseLevels) {
        this.addParameterByEnum(this._QueryAttr_LicenseLevel, licenseLevels);
    }

    /*licenseValidTime:Date*/
    setParamByLicenseValidTime(licenseValidTime) {
        this.addParameter(this._QueryAttr_LicenseValidTime, licenseValidTime);
    }

    /*startDate:Date, endDate:Date*/
    setParamByLicenseValidTime_Range(startDate, endDate) {
        this.addDateParameterByRange(this._QueryAttr_LicenseValidTime, startDate, endDate);
    }

    /*licenseNoFileID:String*/
    setParamByLicenseNoFileID(licenseNoFileID) {
        this.addParameter(this._QueryAttr_LicenseNoFileID, licenseNoFileID);
    }

    /*licenseNoFileIDs:String[]*/
    setParamByLicenseNoFileID_Enum(licenseNoFileIDs) {
        this.addParameterByEnum(this._QueryAttr_LicenseNoFileID, licenseNoFileIDs);
    }

    /*isLocal:boolean*/
    setParamByIsLocal(isLocal) {
        this.addParameter(this._QueryAttr_IsLocal, isLocal);
    }

    /*legalRepIDCard:String*/
    setParamByLegalRepIDCard(legalRepIDCard) {
        this.addParameter(this._QueryAttr_LegalRepIDCard, legalRepIDCard);
    }

    /*legalRepIDCards:String[]*/
    setParamByLegalRepIDCard_Enum(legalRepIDCards) {
        this.addParameterByEnum(this._QueryAttr_LegalRepIDCard, legalRepIDCards);
    }
    /*establishmentDate:Date*/
    setParamByEstablishmentDate(establishmentDate) {
        this.addParameter(this._QueryAttr_EstablishmentDate, establishmentDate);
    }
    /*establishmentDate:Date*/
    setParamByEaAreaCode(eaAreaCode) {
        this.addParameter(this._QueryAttr_EaAreaCode, eaAreaCode);
    }
}